import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import MuiStepper from '@material-ui/core/Stepper';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Edit from '@material-ui/icons/Edit';
import React, { FunctionComponent } from 'react';
import { colors } from '../../theme/theme';

const useStyles = makeStyles((theme: Theme) => ({
	root: {},
	stepper: {
		backgroundColor: 'transparent',
	},
	iconCompleted: {
		color: 'white',
		backgroundColor: colors.black,
		borderRadius: '50%',
		padding: '2px',
		width: '20px',
		height: '20px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	editIcon: {
		width: '18px',
		height: '18px',
	},
	label: {},
	labelCompleted: {
		fontWeight: 400,
	},
	button: {
		marginRight: '10px',
	},
	backButton: {
		marginRight: '10px',
	},
	completed: {
		display: 'inline-block',
	},
	instructions: {
		marginTop: '10px',
		marginBottom: '10px',
	},
	verticalButton: {
		marginBottom: '3px',
		justifyContent: 'center',
	},
	verticalStep: {
		width: '100%',
	},
}));

interface Props {
	steps: string[];
	activeStep: number;
	isVertical?: boolean;
	handleStep(activeStep: number): void;
}

export const Stepper: FunctionComponent<Props> = (props) => {
	const { activeStep, handleStep, steps } = props;
	const classes = useStyles();

	function isStepComplete(step: number): boolean {
		return activeStep > step;
	}

	const getOrientation = () => {
		if (props.isVertical) {
			return 'vertical';
		}

		return 'horizontal';
	};

	return (
		<div className={classes.root}>
			<MuiStepper
				nonLinear
				orientation={getOrientation()}
				alternativeLabel
				className={classes.stepper}
				activeStep={activeStep}
			>
				{steps.map((label, index) => {
					const stepProps: any = {};
					const buttonProps: any = {};
					//TODO replace steps matching label from string to object (label, key, name)
					if (label.includes("-"))
						label = label.substring((label.indexOf("-")+1))

					return (
						<Step
							key={label}
							classes={{
								vertical: classes.verticalStep,
							}}
							{...stepProps}
						>
							<StepButton
								data-cy={'step-button-' + index}
								classes={{
									vertical: classes.verticalButton,
								}}
								onClick={handleStep(index)}
								completed={isStepComplete(index)}
								{...buttonProps}
							>
								<StepLabel
									classes={{
										root: classes.label,
										completed: classes.labelCompleted,
									}}
									StepIconProps={{
										classes: {
											completed: classes.iconCompleted,
										},
										icon: isStepComplete(index) ? (
											<div className={classes.iconCompleted}>
												<Edit className={classes.editIcon} />
											</div>
										) : (
											index + 1
										),
									}}
								>
									{label}
								</StepLabel>
							</StepButton>
						</Step>
					);
				})}
			</MuiStepper>
		</div>
	);
};
